export default "__VITE_ASSET__CqquaFBT__"